

module.exports = (hsl) => `hsl(${hsl.hue}, ${~~(hsl.sat * 100)}%, ${~~(hsl.lum * 100)}%)`;



// WEBPACK FOOTER //
// ./src/utilities/color/factories/functions/hsl/toCss.js